<button type="button" class="view-action-icon-btn view-action-icon-btn--labeled"
  [class.has-changes]="hasHiddenColumns"
  [matMenuTriggerFor]="columnMenu" (menuOpened)="searchControl.reset()"
  [matTooltip]="hasHiddenColumns
    ? 'Edit column visibility — showing ' + visibleCount + ' of ' + totalCount + ' columns'
    : 'Edit column visibility'"
  matTooltipPosition="above">
  <mat-icon svgIcon="c:columns"></mat-icon>
  <span>Edit Columns</span>
  @if (hasHiddenColumns) {
    <!-- aria-hidden: the tooltip above already states the count, so this would just be noise. -->
    <span class="view-action-icon-btn__dot" aria-hidden="true"></span>
  }
</button>

<mat-menu #columnMenu="matMenu" class="column-chooser-menu" xPosition="before">
  <!-- matMenuContent renders lazily on open, so the panel is only built once it's actually shown. -->
  <ng-template matMenuContent>
    <div class="column-chooser-panel">
      <div class="column-chooser-header">
        <div class="column-chooser-title">
          <span class="column-chooser-title__label">Columns</span>
          <span class="column-chooser-title__count">{{ visibleCount }} of {{ totalCount }} shown</span>
        </div>

        <mat-form-field appearance="outline" subscriptSizing="dynamic"
          class="cmn-sm-form-field hide-hint column-chooser-search">
          <mat-icon matPrefix svgIcon="c:search"></mat-icon>
          <input type="text" matInput placeholder="Find a column" [formControl]="searchControl"
            (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()" />
        </mat-form-field>
      </div>

      <!-- Master toggle. Sits outside the scroll area so it stays reachable in a long list. -->
      @if (filteredColumns.length) {
        <div class="column-chooser-selectall">
          <mat-checkbox class="column-chooser-item" color="primary"
            [checked]="allFilteredVisible"
            [indeterminate]="someFilteredVisible"
            (change)="toggleAll()"
            (click)="$event.stopPropagation()">
            {{ isFiltering ? 'Select all ' + filteredColumns.length + ' matching' : 'Select all' }}
          </mat-checkbox>
        </div>
      }

      <div class="column-chooser-list">
        @for (col of filteredColumns; track col.field) {
          <mat-checkbox class="column-chooser-item" color="primary"
            [checked]="!isHidden(col.field)"
            (change)="toggle(col.field)"
            (click)="$event.stopPropagation()">
            {{ col.headerText }}
          </mat-checkbox>
        } @empty {
          <div class="column-chooser-empty">
            <mat-icon svgIcon="c:search-slash"></mat-icon>
            <span>No matching columns</span>
          </div>
        }
      </div>

    </div>
  </ng-template>
</mat-menu>
